import { ApolloClient } from '@apollo/client';
import { cache } from './cache';

export const client = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL_API_URL,
  credentials: 'include', // We use cookie to persist the session
  cache,
});
